export interface Dimension {
  unit: string;
  value: number;
}
